import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';
import { getEnv } from '../../AppConfigs';

const SPSiteId = getEnv('REACT_APP_SP_SITE_ID');
const SPListId = getEnv('REACT_APP_TRAVEL_CARD_REQUEST_LIST_ID');

const expand = 'expand=fields(select=Title, eDescription, eStage,eSuggestion,eBaseId, ePurpose, eDeadline, eArea, eRequestLetter, eDocumentary, eDocumentAttach, eContent, eFileContent, eDeptHeadComment, eITLeadComment, eITHeadComment, eAssigneeComment, eApprovedBy, eApprovedDate,eApprovedStatus, eApprovedByITLead,eApprovedByITLeadStatus, eApprovedByITLeadDate,eApprovedByITHead ,eApprovedByITHeadStatus, eApprovedByITHeadDate, eAssignee,eAssigneeStatus,eAssigneeStatusDate, eRequestStatus, eRequestType, eSoftwareId, eDepartment, eUnit, ePhoneNumber, eComments, ePins)';
export class TravelCardRequestService {

  static async getTravelCardRequests(email: string, status?: string) {
    if (email.toLowerCase() === 'botit@viags.vn' || email.toLowerCase() === 'huongptt@viags.vn' || email.toLowerCase() === 'hieptd@viags.vn' || email.toLowerCase() === 'anhttt@viags.vn'
      || email.toLowerCase() === 'thiennv@viags.vn' || email.toLowerCase() === 'huongdtt@viags.vn') {
      return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`))
        .then(res => res.data.value)
        .catch(err => { throw new RequestError(err) });
    }
    else {
      let filter = `filter=(startswith(fields/eCreatedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') or startswith(fields/eApprovedByITHead,'${email.toLowerCase()}') or startswith(fields/eAssignee,'${email.toLowerCase()}'))`;
      return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}&$top=1000`))
        .then(res => res.data.value)
        .catch(err => { throw new RequestError(err) });
    }
  }

  static async getTravelCardRequestsApprovalHistory(email: string) {
    let filter = `filter=(startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') or startswith(fields/eApprovedByITHead,'${email.toLowerCase()}') or startswith(fields/eAssignee,'${email.toLowerCase()}'))`;
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async getMyTravelCardRequests(email: string) {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`))
      .then(res => res.data.value.filter((o: any) => o.createdBy.user.email.toLowerCase() === email.toLowerCase()))
      .catch(err => { throw new RequestError(err) });
  }

  static async getTravelCardRequest(id: any) {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}?${expand}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async addTravelCardRequest(leaveRequest: any) {
    return api.post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), leaveRequest)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async updateTravelCardRequest(id: any, fields: any) {
    return api.patch(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`), fields)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async deleteTravelCardRequest(id: any) {
    return api.delete(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async getHistory(id: any) {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/versions`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

}